import { skippedTabs } from "./helpers";

//file: default-reporter.js version 1.3
export function r(d) {
	const a4 = [595.28, 841.89]; // for a4 size paper width and height
	const imgFitSize = a4[0] / 2 - 60;
	const allowedTypes = ["string", "integer", "number", "boolean"];
	const eval2 = eval; //this is workaround for rollup (https://github.com/rollup/rollup/wiki/Troubleshooting#avoiding-eval)

	function _getValue(v) {
		return v ? v : "";
	}

	function _getTableRow(cell, colspan) {
		var jsonCell = {
			border: [false, false, false, true],
			text: [
				{
					text: cell.text + (cell.group ? '' : ":"),
					style: cell.group ? "tableGroupLblStyle" : "tableLblStyle"
				},
				{
					text: "\n\n",
					style: "tableLblMarginStyle"
				},
				{ text: _getValue(cell.value) }
			],
			unbreakable: true
		};
		if (colspan && Number.isInteger(colspan)) {
			jsonCell.colSpan = colspan;
		}
		return jsonCell;
	}

	function _getTableBody(rows) {
		var body = [],
				index = 0,
				stab = { border: [false, false, false, false], text: "" };

		rows.forEach(e => {
			let row = null;
			if (Array.isArray(e)) {
				let c1 = e[0] ? _getTableRow(e[0]) : stab;
				let c2 = e[1] ? _getTableRow(e[1]) : stab;
				row = [c1, c2];
			} else if (index === 0) {
				row = [_getTableRow(e, 2), stab];
			} else {
				row = [_getTableRow(e, 2)];
			}
			body.push(row);
			++index;
		});

		if (rows.length == 0) {
			body.push([{}, {}]);
		}

		return body;
	}

	function _getAllImages(data) {
		if (!data || !data.images || !data.inspection) return [];

		let filterArr = data.inspection.not_in_report_images || [];
		var imagesJson = data.images.filter(i => filterArr.indexOf(i.id) === -1)
			.map(i => ({
				image: i.dataUrl,
				fit: [a4[0] * 0.95, a4[1] * 0.8],
				alignment: "center",
				margin: [10, 10]
			}));
		return imagesJson;
	}

	function _getAllDrawings(data) {
		if (!data || !data.drawings) return [];

		let filterArr = data.inspection.not_in_report_images || [];
		var drawingsJson = data.drawings.filter(i => filterArr.indexOf(i.id) === -1)
			.map(d => ({
				image: d.dataUrl,
				fit: [a4[0] * 0.95, a4[1] * 0.8],
				alignment: "center",
				margin: [10, 10]
			}));
		return drawingsJson;
	}

	function _getDynamicContent(data) {
		const schema = data.inspection.type.schema;
		let tabs = schema.order
			.filter(key => (skippedTabs.indexOf(key) === -1 && schema.properties.hasOwnProperty(key)))
			.map(key => schema.properties[key]);

		let content = [];
		tabs.forEach(tab => {
			let header = {
				pageBreak: "before",
				text: _getValue(tab.title),
				style: "header",
				headlineLevel: 1,
				tocItem: true
			};
			content.push(header);

			let r = null;
			if (tab.type == "object") {
				r = _processObject(tab, data);
			} else if (tab.type == "array") {
				r = _processArrayObject(tab, data);
			}
			if (r) {
				content.push(r);
			}
		});

		return content;
	}

	function _normalizeTitle(t) {
		t = _getValue(t);
		return t.replace("*", "").trim();
	}

	function _getDataValue(context, data) {
		var result = "";
		try {
			let contextItems = context.split('.');
			result = contextItems.reduce((acc, curr) => {
				return acc = acc[curr];
			}, data.inspection);
		} catch (err) { }
		return result;
	}
    
	function _getData(context, data) {
		var result = "";
		try {
			let contextItems = context.split('.');
			contextItems.pop();
			result = contextItems.reduce((acc, curr) => {
				return acc = acc[curr];
			}, data.inspection);
		} catch (err) { }
		return result;
	}
    
	function _processField(tableData, field, context, data) {
		if (allowedTypes.indexOf(field.type) === -1) return;

		var dataItem = {
			text: _normalizeTitle(field.title),
			value: _getDataValue(context, data)
		};
		if (field.type === "string") {
			switch (field.renderingType) {
				case "dropdown":
					for (const lbl of field.labels) {
						if (lbl.val == dataItem.value) {
							dataItem.value = lbl.text;
							break;
						}
					}
					break;
				case "multiline":
					dataItem.fullline = true;
					break;
				case "date-time":
					let dt = new Date(dataItem.value);
					dataItem.value = dt.toLocaleString();
					break;
				case "date":
					let d = new Date(dataItem.value);
					dataItem.value = d.toLocaleDateString();
					break
				case "time":
					let t = new Date(dataItem.value);
					dataItem.value = t.toLocaleTimeString();
					break;
				case "output":
					dataItem.value = "";
					let _func = field.func ? eval2("(" + field.func + "\n)") : null;
					if (typeof _func === "function") {
						let localContext = _getData(context, data);
						dataItem.value = _func(data.inspection, localContext);
					}
					break;
			}
		} else if (field.type === 'boolean') {
			dataItem.value = dataItem.value ? '(+)' : '(-)';
		}
		tableData.push(dataItem);
	}

	function _makePairs(arr) {
		var pairedArr = [];
		var pair = [];
		for (let i = 0; i < arr.length; i++) {
			if (arr[i].fullline) {
				if (pair.length > 0) {
					pairedArr.push(pair);
					pair = [];
				}
				pairedArr.push(arr[i]);
				continue;
			}
			pair.push(arr[i]);
			if (pair.length === 2) {
				pairedArr.push(pair);
				pair = [];
			}
		}
		if (pair.length > 0)
			pairedArr.push(pair);


		return pairedArr;
	}

	function _getConnectedPictures(data, connectedImages) {
		var pics = [];
		for (const i of data.images) {
			if (connectedImages.hasOwnProperty(i.id)) {
				pics.push({
					image: i.dataUrl,
					fit: [imgFitSize, imgFitSize],
					margin: [0, 5, 0, 5],
					alignment: "left"
				});
				pics.push({ text: "Image Name: " + (i.description || i.propertyName), fontSize: 8 });
			}
		}
		for (const i of data.drawings) {
			if (connectedImages.hasOwnProperty(i.id)) {
				pics.push({
					image: i.dataUrl,
					fit: [imgFitSize, imgFitSize],
					margin: [0, 5, 0, 5],
					alignment: "left"
				});
				pics.push({ text: "Drawing Name: " + (i.description || i.propertyName), fontSize: 8 });
			}
		}
		return pics;
	}
    
	function _getConnectedImages(tab, key, data) {
		try {
			return data.inspection[tab][key].connected_images || {};
		} catch (error) {
			return {};
		}
	}

	function _processObject(tab, data) {
		var result = [];
		for (const cardName of tab.order) {
			if (!tab.properties.hasOwnProperty(cardName)) continue;

			// card level
			const card = tab.properties[cardName];
			let tableData = [];

			for (const fieldName of card.order) {
				if (!card.properties.hasOwnProperty(fieldName)) continue;

				const field = card.properties[fieldName];
				if (field.type === 'object') {
					// group level
					let group = field;
					let groupName = fieldName;
					var dataItem = {
						text: _normalizeTitle(group.title),
						value: '',
						fullline: true,
						group: true
					};
					tableData.push(dataItem);
                    
					for (const groupFieldName of group.order) {
						// group fields level
						const groupField = group.properties[groupFieldName];
						let groupFieldContext = [tab.name, cardName, groupName, groupFieldName].join('.');
						_processField(tableData, groupField, groupFieldContext, data);    
					}    
				} else {
					// fields level
					let fieldContext = [tab.name, cardName, fieldName].join('.');
					_processField(tableData, field, fieldContext, data);
				}
			}

			tableData = _makePairs(tableData);

			let connectedImages = _getConnectedImages(tab.name, cardName, data);
			let images = _getConnectedPictures(data, connectedImages);

			result.push([
				{
					text: _getValue(card.title),
					style: "subheader",
					headlineLevel: 2
				},
				{
					columns: [
						{
							width: "*",
							stack: images
						},
						{
							width: "*",
							stack: [
								{
									style: "tableStyle",
									table: {
										headerRows: 0,
										widths: ["50%", "50%"],
										body: _getTableBody(tableData)
									},
									layout: {
										hLineColor: function (i, node) {
											try {
												if (node.table.body[i - 1][0].text[0].style === "tableGroupLblStyle") {
													return '#4285F4';
												}    
											} catch (error) {}
											return 'gray'; 
										},
										vLineColor: "gray"
									}
								}
							]
						}
					]
				}
			]);
		}
		return result;
	}

	function _processArrayObject(tab, data) {
		var result = [];

		const tabData = data.inspection[tab.name];
		if (!tabData || tabData.length < 1) return;

		for (let index = 0; index < tabData.length; index++) {
			let tableData = [];
            
			for (const fieldName of tab.items.order) {
				if (!tab.items.properties.hasOwnProperty(fieldName)) continue;
    
				const field = tab.items.properties[fieldName];
				if (field.type === 'object') {
					// group level
					let group = field;
					let groupName = fieldName;
					var dataItem = {
						text: _normalizeTitle(group.title),
						value: '',
						fullline: true,
						group: true
					};
					tableData.push(dataItem);
                    
					for (const groupFieldName of group.order) {
						// group fields level
						const groupField = group.properties[groupFieldName];
						let groupFieldContext = [tab.name, index, groupName, groupFieldName].join('.');
						_processField(tableData, groupField, groupFieldContext, data);    
					}
				} else {
					// fields level
					let fieldContext = [tab.name, index, fieldName].join('.');
					_processField(tableData, field, fieldContext, data);
				}
			}

			tableData = _makePairs(tableData);

			let connectedImages = _getConnectedImages(tab.name, index, data);
			let images = _getConnectedPictures(data, connectedImages);

			result.push([
				{
					text: tab.showIndex ? (_getValue(tab.items.title) + " #" + index) : _getValue(tab.items.title),
					style: "subheader",
					headlineLevel: 2
				},
				{
					columns: [
						{
							width: "*",
							stack: images
						},
						{
							width: "*",
							stack: [
								{
									style: "tableStyle",
									table: {
										headerRows: 0,
										widths: ["50%", "50%"],
										body: _getTableBody(tableData)
									},
									layout: {
										hLineColor: function (i, node) {
											try {
												if (node.table.body[i - 1][0].text[0].style === "tableGroupLblStyle") {
													return '#4285F4';
												}    
											} catch (error) {}
											return 'gray'; 
										},
										vLineColor: "gray"
									}
								}
							]
						}
					]
				}
			]);
		}
		return result;
	}

	function getDocumentDefinition(data) {
		var content = [
			{
				stack: [
					data.inspection.type.name,
					{
						text: data.inspection.name,
						style: "title-page-subheader"
					},
					{
						image: "coverImage",
						fit: [a4[0] * 0.8, 450],
						margin: [0, 40, 0, 0],
						alignment: "center"
					}
				],
				style: "title-page-header"
			},
			{
				pageBreak: "before",
				toc: {
					title: {
						text: "Table of Content",
						style: "header"
					},
					numberStyle: { bold: true }
				}
			}
		];

		const dynamicContent = _getDynamicContent(data);
		for (let i = 0; i < dynamicContent.length; i++) {
			const c = dynamicContent[i];
			content.push(c);
		}

		let imgs = _getAllImages(data);
		if (imgs.length > 0) {
			content.push({
				pageBreak: "before",
				text: "Afbeeldingen",
				style: "header",
				tocItem: true
			});
			content.push(imgs);
		}

		let drws = _getAllDrawings(data);
		if (drws.length > 0) {
			content.push({
				pageBreak: "before",
				text: "Tekeningen",
				style: "header",
				tocItem: true
			});
			content.push(drws);
		}

		var docDefinition = {
			pageSize: "A4",
			pageOrientation: "portrait",
			pageMargins: [40, 60, 40, 40],
			info: {
				title: data.inspection.type.name,
				author: "john doe",
				subject: "subject of document",
				keywords: "keywords for document",
				producer: "Traiectum Digital Solutions",
				creationDate: new Date(),
				modDate: new Date()
			},
			header: [
				{
					columns: [
						{
							width: "auto",
							stack: [
								{
									image: _getTDSUrl(),
									width: 64,
									height: 20,
									margin: [20, 5, 5, 5]
								}
							]
						},
						{
							width: "*",
							text: data.inspection.type.name,
							alignment: "right",
							margin: [0, 10, 10, 0]
						}
					],
					columnGap: 0
				},
				{
					canvas: [
						{
							type: "line",
							x1: 10,
							y1: 1,
							x2: a4[0] - 10,
							y2: 1,
							lineWidth: 0.5
						}
					]
				}
			],
			footer: function (currentPage, pageCount, pageSize) {
				//disable footer on the first page
				if (currentPage == 1)
					return {};

				return [
					{
						canvas: [
							{
								type: "line",
								x1: 250,
								y1: 1,
								x2: a4[0] - 250,
								y2: 1,
								lineWidth: 0.5
							}
						]
					},
					{
						columns: [
							{
								width: "40%",
								text: ""
							},
							{
								text: currentPage.toString() + " of " + pageCount + " page" + (pageCount > 1 ? "s" : ""),
								width: "20%",
								alignment: "center",
								margin: [10, 16],
								style: "small"
							},
							{
								text: "\u00A9 " + new Date().getFullYear() + " All rights reserved Traiectum Digital Solutions",
								width: "40%",
								alignment: "right",
								margin: [10, 16],
								style: "small"
							}
						]
					}
				];
			},
			content: content,
			styles: {
				"title-page-header": {
					fontSize: 18,
					bold: true,
					alignment: "right",
					margin: [0, 190, 0, 80]
				},
				"title-page-subheader": { fontSize: 14 },
				header: {
					color: "#FC5356",
					fontSize: 18,
					bold: true,
					margin: [0, 10, 0, 18]
				},
				subheader: {
					color: "#FC5356",
					fontSize: 15,
					bold: true,
					margin: [0, 5, 0, 12]
				},
				small: { fontSize: 8 },
				tableStyle: {
					margin: [0, 5, 0, 15],
					color: "black",
					fontSize: 13
				},
				tableLblStyle: {
					color: "#505050",
					fontSize: 11
				},
				tableGroupLblStyle: {
					color: "#4285F4",
					fontSize: 13
				},
				tableLblMarginStyle: { fontSize: 4 }
			},
			pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
				//TODO: check it carefully, it almost work
				// https://github.com/bpampuch/pdfmake/blob/master/README.md#dynamically-control-page-breaks-for-instance-to-avoid-orphan-children
				return (
					(currentNode.headlineLevel === 1 || currentNode.headlineLevel === 2) && followingNodesOnPage.length === 0
				);
			},
			images: {
				coverImage:
                    (data.cover && data.cover.dataUrl ? data.cover.dataUrl : "") ||
                    "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII="
			}
		};

		return docDefinition;
	}

	return getDocumentDefinition(d);

	function _getTDSUrl() {
		return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
	}
}
